import React from 'react';
import { colors, spacing, typography } from '../tokens/index.js';

const Input = ({
  type = 'text',
  placeholder = '',
  value,
  onChange,
  disabled = false,
  error = false,
  label = '',
  helperText = '',
  size = 'medium',
  className = '',
  ...props
}) => {
  const getSizeStyles = (size) => {
    const sizes = {
      small: {
        padding: '0.5rem 0.75rem',
        fontSize: typography.fontSize.sm,
        height: '2rem',
      },
      medium: {
        padding: spacing.component.inputPadding,
        fontSize: typography.fontSize.base,
        height: spacing.component.inputHeight,
      },
      large: {
        padding: '1rem 1.25rem',
        fontSize: typography.fontSize.lg,
        height: '3rem',
      }
    };
    return sizes[size] || sizes.medium;
  };

  const sizeStyles = getSizeStyles(size);

  const inputStyles = {
    ...sizeStyles,
    width: '100%',
    fontFamily: typography.fontFamily.primary,
    fontWeight: typography.fontWeight.light,
    backgroundColor: colors.background.secondary,
    color: colors.text.primary,
    border: `1px solid ${error ? colors.error : colors.border.default}`,
    borderRadius: spacing.borderRadius.base,
    outline: 'none',
    transition: 'all 0.15s ease-in-out',
    '&::placeholder': {
      color: colors.text.muted,
    },
    '&:focus': {
      borderColor: error ? colors.error : colors.text.primary,
      boxShadow: `0 0 0 2px ${error ? colors.alpha.light24 : colors.alpha.light12}`,
    },
    '&:disabled': {
      opacity: 0.6,
      cursor: 'not-allowed',
      backgroundColor: colors.background.tertiary,
    }
  };

  const labelStyles = {
    display: 'block',
    marginBottom: spacing[2],
    fontSize: typography.fontSize.sm,
    fontWeight: typography.fontWeight.normal,
    color: colors.text.primary,
    fontFamily: typography.fontFamily.primary,
  };

  const helperTextStyles = {
    marginTop: spacing[1],
    fontSize: typography.fontSize.xs,
    color: error ? colors.error : colors.text.muted,
    fontFamily: typography.fontFamily.primary,
  };

  return (
    <div className={`ds-input-wrapper ${className}`}>
      {label && (
        <label style={labelStyles}>
          {label}
        </label>
      )}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className="ds-input"
        style={inputStyles}
        {...props}
      />
      {helperText && (
        <div style={helperTextStyles}>
          {helperText}
        </div>
      )}
    </div>
  );
};

export default Input;
